type StringWithPercent = string;

export function randomNumber(min: number = 0, max: number = 10): number {
  return Math.floor(Math.random() * (max - min) + min);
}
export function randomNumberWithPercent(min: number = 30, max: number = 60): StringWithPercent {
  return `${randomNumber(min, max)}%`;
}
